module.exports = __webpack_public_path__ + "img/pluto144.08f2e00c.jpg";